import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Table } from 'antd';
import moment from 'moment';
import util from '@util/index';

class TableRelated extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  handleTableChange = pagination => {
    this.props.handleTableChange(pagination);
  };

  columns = () => {
    const type = ['押金', '工位', '地址'];
    return [
      {
        title: '账单编号',
        dataIndex: 'no',
        width: 200,
        render: (text, record) => <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>,
      },
      {
        title: '款项类型',
        dataIndex: 'type',
        width: 200,
        render: (text, record) => <span>{type[text]}</span>,
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        width: 250,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '匹配金额',
        dataIndex: 'confirm',
        width: 100,
        render: (text, record) => <span>{util.numberFormat(record.confirm || 0)}</span>,
      },
    ];
  };

  render() {
    const {
      data: { list, pagination },
    } = this.props;
    return (
      <Table
        rowKey="uuid"
        rowSelection={{}}
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        onChange={this.handleTableChange}
      />
    );
  }
}
export default connect(state => ({
  accountInfo: state.account_info,
}))(TableRelated);



// WEBPACK FOOTER //
// ./src/components/incubator/income/TableRelateDetail.js